// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfileTagsManagement_container__2i8Um","title":"ProfileTagsManagement_title__8uaqk"};